import t from "./FindAnythingButton.vue2.js";
import o from "../../_virtual/_plugin-vue_export-helper.js";
const _ = /* @__PURE__ */ o(t, [["__scopeId", "data-v-62693e42"]]);
export {
  _ as default
};
